var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "form-modal" } },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.addAnItem"))),
      ]),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticClass: "types",
          attrs: { "show-search": "" },
          model: {
            value: _vm.input.type,
            callback: function ($$v) {
              _vm.$set(_vm.input, "type", $$v)
            },
            expression: "input.type",
          },
        },
        _vm._l(_vm.types, function (type, index) {
          return _c(
            "a-select-option",
            { key: index, attrs: { value: type.value } },
            [_vm._v("\n            " + _vm._s(type.label) + "\n        ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-area" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.input.label,
              expression: "input.label",
            },
          ],
          staticClass: "label-input",
          attrs: { placeholder: _vm.$t("message.newTitleContent") },
          domProps: { value: _vm.input.label },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.input, "label", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "required-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.input.required,
              expression: "input.required",
            },
          ],
          staticClass: "input-checkbox",
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.input.required)
              ? _vm._i(_vm.input.required, null) > -1
              : _vm.input.required,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.input.required,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.input, "required", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.input,
                      "required",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.input, "required", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "text" }, [
          _vm._v(_vm._s(_vm.$t("message.required"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _c(
          "span",
          {
            staticClass: "btn",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("message.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "btn add",
            on: {
              click: function ($event) {
                return _vm.saveItem()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("message.saveItem")))]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }